import http from '../../../Utils/http';
const PricingEditorUpdation = {
  name: 'pricingEditorUpdation',
  state: {
    editorCreationLoading: false,
    editorCreationError: '',
    editorCreationMessage: '',
    permissions: [
      'organization:view',
      'organization:create',
      'organization:delete',
      'organization:update',
    ],
    editorCreation: {},
    editorUpdation: {},
    editorUpdationLoading: false,
    editorUpdationMessage: '',
    editorUpdationError: ''
  },
  reducers: {
    editorCreationRequested(state) {
      return {
        ...state,
        editorCreationLoading: true,
        editorCreationError: '',
        editorCreationMessage: ''
      };
    },
    editorCreationReceived(state, payload) {
      return {
        ...state,
        editorCreation: payload,
        editorCreationLoading: false,
        editorCreationMessage: 'Changes have been saved.',
        editorCreationError: '',
      }
    },
    editorCreationRequestFailed(state, payload) {
      return {
        ...state,
        editorCreation: payload,
        editorCreationMessage: '',
        editorCreationLoading: false,
      };
    },

    editorUpdationRequested(state) {
      return {
        ...state,
        editorUpdationLoading: true,
        editorUpdationError: '',
        editorUpdationMessage: ''
      };
    },
    editorUpdationReceived(state, payload) {
      return {
        ...state,
        editorUpdationLoading: false,
        editorUpdation: payload,
        editorUpdationError: '',
      }
    },
    editorUpdationFailed(state, payload) {
      return {
        ...state,
        editorUpdationError: 'error',
        editorUpdation: {},
        editorUpdationLoading: false,
      };
    },

  },
  effects: (dispatch) => ({
    async requestForPicingEditorCreation(data) {
      try {
        this.editorCreationRequested();
        const response = await http.post(`savvy/plans`, data);
        this.editorCreationReceived(response.data.message);
      } catch (err) {
        this.editorCreationRequestFailed(err.response.data.error)
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }
    },
    async requestForPricingEditorUpdation(data) {
      try {
        this.editorUpdationRequested();
        const { id } = data;
        const response = await http.put(`savvy/plans/${id}`, data);
        this.editorUpdationReceived(response.data.userInfo);
      } catch (err) {
        this.editorUpdationFailed(err.response.data.error)
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }
    },
    async clearData() {
      this.profileUpdateReceived('');
    }
  }),
};

export default PricingEditorUpdation;